import { uniqBy } from 'lodash';

const initialState = {
  requirements: [],

  plansLoading: false,
  plansBackgroundLoading: false,

  gradPlanId: undefined,

  planStatus: {
    topLevelRequirements: [],
    programSlots: [],
  },

  planSummary: {},

  courseSearchBusy: false,
  searchedCourses: [],
  courseSearchStatus: {
    count: undefined,
    next: undefined,
    previous: undefined,
  },
  nonPlannedCourse: {},
  planHistory: [],
  planConfig: {},
  planContext: {},
  districtContext: {},
  viewPlanActivityId: '',
  viewSupplementalPlanRequirement: {},
  activeSupplementalRequirementId: undefined,
};

// eslint-disable-next-line complexity
export default (state = initialState, action) => {
  switch (action.type) {
    case 'PLAN_DETAILS_LOADING':
      return {
        ...state,
        plansLoading: action.mode,
      };
    case 'COURSE_PLANNING.PLAN_DETAILS_BACKGROUND_LOADING':
      return {
        ...state,
        plansBackgroundLoading: action.mode,
      };
    case 'POPULATE_PLAN_DETAILS': {
      return {
        ...state,
        gradPlanId: action.gradPlanId,
        planStatus: action.planStatus,
        requirements: action.requirements,
      };
    }
    case 'POPULATE_PLAN_SUMMARY':
      return {
        ...state,
        planSummary: action.partial
          ? {
              ...state.planSummary,
              ...action.planSummary,
            }
          : action.planSummary,
      };
    case 'REMOVE_SUPPLEMENTAL_COMPARISON':
      return {
        ...state,
        gradPlanId: null,
      };
    case 'SET_COURSE_SEARCHING_BUSY':
      return {
        ...state,
        courseSearchBusy: action.mode,
      };
    case 'POPULATE_SEARCHED_COURSES':
      return {
        ...state,
        searchedCourses: action.append
          ? uniqBy([...state.searchedCourses, ...action.courses], 'uuid')
          : action.courses,
        courseSearchBusy: false,
      };
    case 'POPULATE_SEARCHED_COURSES_STATUS':
      return {
        ...state,
        courseSearchStatus: action.courseSearchStatus,
      };
    case 'POPULATE_NON_PLANNED_COURSE':
      return {
        ...state,
        nonPlannedCourse: action.course,
      };
    case 'POPULATE_PLAN_HISTORY':
      return {
        ...state,
        planHistory: action.planHistory,
      };
    case 'POPULATE_PLAN_CONFIG':
      return {
        ...state,
        planConfig: action.planConfig,
      };
    case 'POPULATE_PLAN_CONTEXT':
      return {
        ...state,
        planContext: action.planContext,
      };
    case 'POPULATE_DISTRICT_CONTEXT':
      return {
        ...state,
        districtContext: action.context,
      };
    case 'POPULATE_ALTERNATE_COURSES':
      return {
        ...state,
        alternateCourses: action.alternateCourses,
      };

    case 'SET_PLAN_CHANGE_ACTIVITY_ID':
      return {
        ...state,
        viewPlanActivityId: action.planId,
      };

    case 'POPULATE_VIEW_SUPPLEMENTAL_PLAN_REQUIREMENT':
      return {
        ...state,
        viewSupplementalPlanRequirement: action.requirement,
        activeSupplementalRequirementId:
          action.requirement && action.requirement.uuid,
      };

    case 'COURSE_PLANNING.ADD_COURSE_TO_REDUX_REQUIREMENT':
      return {
        ...state,
        planSummary: {
          ...state.planSummary,
          topLevelRequirements: state?.planSummary?.topLevelRequirements?.map(
            requirement => {
              if (
                requirement.uuid === action.coursePayload.topLevelRequirementId
              ) {
                return {
                  ...requirement,
                  coursesPlanned: requirement.coursesPlanned.find(
                    e => e.uuid === action.coursePayload.course.uuid,
                  )
                    ? requirement.coursesPlanned.map(plannedCourse => {
                        if (
                          plannedCourse.uuid ===
                          action.coursePayload.course.uuid
                        ) {
                          return {
                            ...plannedCourse,
                            termsSelected: [
                              ...plannedCourse.termsSelected,
                              {
                                grade: action.coursePayload.grade,
                                academicTerm: {
                                  academicTerm:
                                    action.coursePayload.academicTerm,
                                },
                                additional: {
                                  status: 'planned',
                                  enrolled: false,
                                  preselected: false,
                                  creditCount:
                                    action.coursePayload.course.credits,
                                  creditAwarded: null,
                                },
                              },
                            ],
                          };
                        }
                        return plannedCourse;
                      })
                    : [
                        ...requirement.coursesPlanned,
                        {
                          ...action.coursePayload.course,
                          termsSelected: [
                            {
                              grade: action.coursePayload.grade,
                              academicTerm: {
                                academicTerm: action.coursePayload.academicTerm,
                              },
                              additional: {
                                status: 'planned',
                                enrolled: false,
                                preselected: false,
                                creditCount:
                                  action.coursePayload.course.credits,
                                creditAwarded: null,
                              },
                            },
                          ],
                        },
                      ],
                };
              }
              return requirement;
            },
          ),
        },
      };
    default:
      return state;
  }
};
